import React, { useCallback } from 'react';
import TableCell from "@mui/material/TableCell";
import IconForCall from "./IconForCall";
import {history1} from "../translate";
import Utils from "../Utils";
import {Tooltip} from "react-tooltip";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import PauseCircleIcon from '@mui/icons-material/PauseCircle';
import Cookies from "js-cookie";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import HistoryIcon from "@mui/icons-material/History";
import TableRow from "@mui/material/TableRow";
import {useSelector} from "react-redux";
import Loader from "./Loader";
import { canListenToRecording as canListenToRecordingRow } from '../helpers/employeePermissions';
import { rowHasSpeechBuddy } from '../helpers/speechBuddy';
const {REACT_APP_SERVER} = process.env;
let color = REACT_APP_SERVER === 'ATS' ? '#0973b9' : '#7ebc0a'

function HistoryLine({ track, trackIndexSet, playingId, r, counter, handleAudio, handleText, background = "#fff", isOpen, setIsOpen, loading, showHistoryIcon = false, historyOpen = false, onHistoryClick }) {
    const profile = useSelector(state => state.users.ursData)
    const profileData = useSelector(state => state.users.userData)
    const employeeData = useSelector(state => state.users.employeeData)
    const speechbuddy = useSelector(state => state.history.speechbuddy)
    const completed = useSelector(state => state.history.completed)
    const speechAllowed = rowHasSpeechBuddy(r, speechbuddy)
    const speechDone = !!(r.isEmotion || completed.find(l => l.id === r.linkedid))
    const isPlaying = playingId && (String(r.uniqueid || r.id) === String(playingId))

    const mayListen = useCallback(
        (row) => canListenToRecordingRow(employeeData, row),
        [employeeData]
    )

    const viewerPlayBlocked = Cookies.get('viewer') && !profile?.isLimited
    const showPlayable = !viewerPlayBlocked && mayListen(r) && !!r.isAudio
    const toggleOpen = () => {
        setIsOpen(isOpen === r.linkedid ? '' : r.linkedid)
    }

    return (
        <TableRow
            style={{cursor: 'pointer', background: isPlaying ? "#edffdc" : background,}}
            className="sip_num" hover role="checkbox" tabIndex={-1}
            >

            <TableCell
                onClick={toggleOpen}
                align="center">
                {
                    r.disposition !== "ANSWERED" &&  r.ext_num?
                    <IconForCall color={history1.callType[3].color}
                                 path={history1.callType[3].path}/>:r.disposition !== "ANSWERED"? <IconForCall color={history1.callType[1].color}
                                                                                                               path={history1.callType[1].path}/>: r.ext_num ?
                        <IconForCall color={history1.callType[2].color}
                                     path={history1.callType[2].path}/> :
                        <IconForCall color={history1.callType[0].color}
                                     path={history1.callType[0].path}/>
                }

            </TableCell>
            <TableCell
            onClick={toggleOpen}
            style={{width: 100 / 8 + '%', fontSize: 10}} align="center">
                {Utils.formatHistoryDateRange(r)}
            </TableCell>
            <TableCell
                onClick={toggleOpen}
                data-tooltip-content={String(r.ext_note ?? '')}
                data-tooltip-id={String(r.id ?? '')}
                style={{width: 100 / 8 + '%'}} align="center">
                <Tooltip className={"tooltip"} id={String(r.id ?? '')}/>

                {r.extension ? r.extension : ''}
            </TableCell>
            <TableCell
                onClick={toggleOpen}
                style={{width: 100 / 8 + '%'}} align="center">
                {Utils.secToHours(Number(r.duration) || 0)}
            </TableCell>

            {(profileData?.id === 10 || profileData?.id === 100) && <TableCell
                onClick={toggleOpen}
                style={{width: 100 / 8 + '%'}} align="center">
                {r?.wait_s ? r.wait_s : 0} {history1.seconds[localStorage.getItem('atsLang') || 1]}
            </TableCell>}
            
            <TableCell
                onClick={toggleOpen}
                style={{width: 100 / 8 + '%'}}
                                   align="center">
                                    {r.line && r.line !== 'null' && r.line !== 'umob' ? r.line : r.ext_num ? r.ext_num[0]:'' }
        </TableCell>
            <TableCell
                onClick={toggleOpen}
            style={{width: 100 / 8 + '%'}}
                               align="center">
                        { r.in_num ? r.in_num : ''}

        </TableCell>
            <TableCell
                onClick={toggleOpen}
                style={{width: 100 / 8 + '%'}}
                               align="center">
            {r.virtual ? Utils.displayShortNumber(r.virtual) : ''}
        </TableCell>
            <TableCell
                onClick={toggleOpen}
                data-tooltip-content={
                    r.disposition === "ANSWERED" && r.status === "Incoming Call"
                        ? (String(r.channel || '').startsWith("SIP/10") ? "Receiver" : "Caller")
                        : r.disposition === "ANSWERED" && r.status === "Out Call"
                        ? (String(r.channel || '').startsWith("SIP/10") ? "Caller" : "Receiver")
                        : r.disposition === "ANSWERED"
                        ? (String(r.channel || '').startsWith("SIP/10") ? "Caller" : "Receiver")
                        : ""
                }
                data-tooltip-id={`disposition-${String(r.id ?? '')}`}
                style={{width: 100 / 8 + '%'}}
                               align="center">
                <Tooltip className={"tooltip"} id={`disposition-${String(r.id ?? '')}`} />
            {r.disposition === "ANSWERED" && r.status === "Incoming Call"
                ? String(r.channel || '').startsWith("SIP/10")
                    ? <>ANSWERED <strong>(R)</strong></>
                    : <>ANSWERED <strong>(C)</strong></>
                : r.disposition === "ANSWERED" && r.status === "Out Call"
                ? String(r.channel || '').startsWith("SIP/10")
                    ? <>ANSWERED <strong>(C)</strong></>
                    : <>ANSWERED <strong>(R)</strong></>
                : r.disposition === "ANSWERED"
                ? String(r.channel || '').startsWith("SIP/10")
                    ? <>ANSWERED <strong>(C)</strong></>
                    : <>ANSWERED <strong>(R)</strong></>
                : (r.disposition != null && r.disposition !== '') ? String(r.disposition) : ''}
        </TableCell>
            <TableCell
                onClick={toggleOpen}
            data-tooltip-content={String(r.dest_note ?? '')}
            data-tooltip-id={String(r.id ?? '')} style={{width: 100 / 8 + '%'}}
            align="center">
            {r.destination ? r.destination : ''}
        </TableCell>
            <TableCell
                onClick={toggleOpen}
                style={{width: 100 / 8 + '%',color:r.rate > 3?color:r.rate > 1?'#ff9b00':r.rate?'red':'#ccc'}} align="center">
                {r.rate ? r.rate :
                    <DoNotDisturbIcon style={{color: '#ccc'}}/>}

            </TableCell>
            <TableCell align="center"
                       style={{width: 100 / 8 + '%', cursor: 'pointer'}}>
                <span className='d-flex history_audio'>
                    {!showPlayable ?
                        <PlayCircleIcon style={{ color: '#ccc' }} /> :
                        isPlaying ?
                            <PauseCircleIcon
                                onClick={() => handleAudio(r)}
                                style={{ color: color }} />
                            : <PlayCircleIcon onClick={() => handleAudio(r)}
                                style={{ color: color }} />

                    }
                    {viewerPlayBlocked || !mayListen(r) || !speechAllowed ?
                        <ChatBubbleIcon style={{ color: '#ccc', pointerEvents: 'none' }} /> :
                        loading === (r.uniqueid || r.id) ?
                            <Loader size={20} /> :
                            <ChatBubbleIcon onClick={() => {
                                handleText(r)}}
                                            style={!r.isAudio ? { color: '#ccc' } : speechDone ? { color: color } : { color: '#52658c' }}/>
                    }
                    {showHistoryIcon ? (
                        <HistoryIcon
                            onClick={(e) => {
                                e.stopPropagation()
                                onHistoryClick?.()
                            }}
                            style={{ color: historyOpen ? color : '#52658c', cursor: 'pointer' }}
                        />
                    ) : null}
                </span>
            </TableCell>

        </TableRow>
    );
}

export default HistoryLine;
